import { HintTooltip, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";

const CourseWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0 !important; 
`;
const CourseName = styled.div<{ isOverflowing?: boolean }>`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  padding-left: 0 !important;

`;

export const CourseWithTooltip:FC<{courseName: string}> = ({ courseName }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const courseNameRef = useRef<HTMLDivElement>(null);
    const is1700 = useBreakpoint(1700);
    const isFullHD = useBreakpoint(1920)
    const [width, setMaxWidth] = useState(650);
    const maxContentLength = 25;

    const navbar = useMemo(() => {
      return document.querySelector('#navbar');
    } , [])

    useEffect(() => {
      if (courseNameRef.current) {
        //@ts-ignore
        const isTextOverflowing = courseNameRef.current.scrollWidth > courseNameRef.current.clientWidth;
        setIsOverflowing(isTextOverflowing);
      }
    }, [courseName, courseNameRef.current, courseNameRef ]);

    useEffect(() => {
      function calculateAvailableSpace() {
        if (!navbar || !courseNameRef?.current || is1700 || courseName?.length < maxContentLength) return;
        const margin = 64; 
        const marginBetweenElements = 24;
        const totalNavWidth = navbar.scrollWidth + margin + 1
        const currentWidth = courseNameRef?.current?.clientWidth
        let availableWidthForLastItem;

        if (isFullHD && window.innerWidth < totalNavWidth) {
          availableWidthForLastItem = Math.max(totalNavWidth - window.innerWidth);
          setMaxWidth(currentWidth - availableWidthForLastItem - margin)
        } 
      };
  
      window.addEventListener('resize', calculateAvailableSpace);
      calculateAvailableSpace();
  
      return () => {
        window.removeEventListener('resize', calculateAvailableSpace);
      };
    }, [navbar, courseNameRef, isFullHD, courseNameRef?.current, is1700]);

    const dropdownTooltipStyles = { background: 'rgb(231, 231, 231)', color: 'rgb(112, 112, 111)', fontSize: '9px', lineHeight: '11px'}

    const isDropdown = useMemo(() => {
      return is1700
    } , [is1700])

    return (
      <CourseWrapper style={{paddingLeft: "0 !important", maxWidth: width || 'max-content'}} ref={courseNameRef}>
        {!isDropdown && <span style={{marginRight: "16px"}}>—</span>}
        {isOverflowing || (courseName.length > 30 && is1700) ? (
          <HintTooltip
            noArrow={true}
            // @ts-ignore
            customStyle={is1700 ? dropdownTooltipStyles : { background: 'rgb(231, 231, 231)', color: 'rgb(112, 112, 111)', width: 'min-content'}}
            positionY= {is1700 ? 'top': 'bottom'}
            text={courseName}
            z={6}
            onWhiteBg
          >
            <CourseName isOverflowing={isOverflowing}>{courseName}</CourseName>
          </HintTooltip>
        ) : (
          <CourseName isOverflowing={isOverflowing}>{courseName}</CourseName>
        )}
      </CourseWrapper>
    );
  };import { HintTooltip, useBreakpoint } from "@brg/ui";
import { LayoutConst } from "core";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";

const CourseWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0 !important; 
`;
const CourseName = styled.div<{ isOverflowing?: boolean }>`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  padding-left: 0 !important;

`;

export const CourseWithTooltip:FC<{courseName: string}> = ({ courseName }) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const courseNameRef = useRef<HTMLDivElement>(null);
    const is1700 = useBreakpoint(1700);
    const isFullHD = useBreakpoint(1920)
    const [width, setMaxWidth] = useState(650);
    const maxContentLength = 25;

    const navbar = useMemo(() => {
      return document.querySelector('#navbar');
    } , [])

    useEffect(() => {
      if (courseNameRef.current) {
        //@ts-ignore
        const isTextOverflowing = courseNameRef.current.scrollWidth > courseNameRef.current.clientWidth;
        setIsOverflowing(isTextOverflowing);
      }
    }, [courseName, courseNameRef.current, courseNameRef ]);

    useEffect(() => {
      function calculateAvailableSpace() {
        if (!navbar || !courseNameRef?.current || is1700 || courseName?.length < maxContentLength) return;
        const margin = 64; 
        const marginBetweenElements = 24;
        const totalNavWidth = navbar.scrollWidth + margin + 1
        const currentWidth = courseNameRef?.current?.clientWidth
        let availableWidthForLastItem;

        if (isFullHD && window.innerWidth < totalNavWidth) {
          availableWidthForLastItem = Math.max(totalNavWidth - window.innerWidth);
          setMaxWidth(currentWidth - availableWidthForLastItem - margin)
        } 
      };
  
      window.addEventListener('resize', calculateAvailableSpace);
      calculateAvailableSpace();
  
      return () => {
        window.removeEventListener('resize', calculateAvailableSpace);
      };
    }, [navbar, courseNameRef, isFullHD, courseNameRef?.current, is1700]);

    const dropdownTooltipStyles = { background: 'rgb(231, 231, 231)', color: 'rgb(112, 112, 111)', fontSize: '9px', lineHeight: '11px'}

    const isDropdown = useMemo(() => {
      return is1700
    } , [is1700])

    return (
      <CourseWrapper style={{paddingLeft: "0 !important", maxWidth: width || 'max-content'}} ref={courseNameRef}>
        {!isDropdown && <span style={{marginRight: "16px"}}>—</span>}
        {isOverflowing || (courseName.length > 30 && is1700) ? (
          <HintTooltip
            noArrow={true}
            // @ts-ignore
            customStyle={is1700 ? dropdownTooltipStyles : { background: 'rgb(231, 231, 231)', color: 'rgb(112, 112, 111)', width: 'min-content'}}
            positionY= {is1700 ? 'top': 'bottom'}
            text={courseName}
            z={6}
            onWhiteBg
          >
            <CourseName isOverflowing={isOverflowing}>{courseName}</CourseName>
          </HintTooltip>
        ) : (
          <CourseName isOverflowing={isOverflowing}>{courseName}</CourseName>
        )}
      </CourseWrapper>
    );
  };